<template>
  <px-lateral-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn color="success"
             small
             class="ml-3 elevation-0 normal-btn-text rounded-tag-small"
             v-on="on">
        Aprovar
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovar frete
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            hide-details
            class="required rounded-tag-small"
            autocomplete="off"
            label="Nota fiscal"
            v-model="numNotaFiscal"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn text class="normal-btn-text" @click="close">
        Fechar
      </v-btn>
      <v-btn color="success" class="elevation-0 normal-btn-text rounded-tag-small"
             :disabled="!numNotaFiscal"
             :loading="loading"
             @click="aprovarFrete">
        Aprovar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>
<script>
import ComprasService from '@/modules/marketplace/compras/compras-service';

export default {
  props: {
    pacote: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      numNotaFiscal: null,
      dialog: false,
    };
  },
  methods: {
    aprovarFrete() {
      this.loading = true;
      ComprasService.aprovarPacote(this.pacote.id, {
        notaFiscal: this.numNotaFiscal,
      })
        .then(() => {
          this.close();
          this.$emit('change');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
